import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Counter from '../counter';
import NumberDisplay from '../number-display';
import styles from './styles.css';

class CircleGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }


  render() {
    const {
      title, color, value, tooltip, half, subTitle,
    } = this.props;

    let label = numeral(value).format('0.0%');
    if (label === '100.0%') {
      label = '100%';
    }

    const percentage = value * 100;
    const atrVal = numeral(value * 100).format('0');

    const chart = (
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.circle}>
            <div className={styles.arc} style={{ borderColor: color }} data-value={atrVal}>
              <div className={styles.pointer} style={{ backgroundColor: color }} />
            </div>
          </div>
          <div className={styles.num}>
            <Counter value={percentage}>
              <NumberDisplay value={percentage} precision={atrVal === '100' ? 0 : 1} />
            </Counter>
            <sup>%</sup>
          </div>
        </div>
        {subTitle !== null && <div className={styles.label}>{subTitle}</div>}
      </div>
    );


    if (tooltip !== null) {
      const tip = (
        <Tooltip id="circle-chart-popover">
          <div className={styles.circleTip}>
            {tooltip}
          </div>
        </Tooltip>
      );
      return (
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={tip}>
          {chart}
        </OverlayTrigger>
      );
    }

    return chart;
  }
}

CircleGraph.propTypes = {
  value: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  tooltip: PropTypes.node,
  half: PropTypes.bool,
};
CircleGraph.defaultProps = {
  value: 0,
  color: '#2196f3',
  title: null,
  subTitle: null,
  tooltip: null,
  half: false,
};

export default CircleGraph;
